"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerActions = exports.DrawerContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.DrawerContext = react_1.default.createContext(undefined);
exports.DrawerActions = (props) => react_1.default.createElement(exports.DrawerContext.Consumer, props);
